<template>
  <div class="w-full">
    <div class="flex flex-col">
      <div v-if="active && Array.isArray(step.steppable.verdict)">
        <PathwayGuidanceVerdict
          v-for="verdict in step.steppable.verdict"
          :key="verdict.id"
          class="p-4 mr-8"
          :guidance="step.steppable"
          :verdict="verdict"
        />
      </div>
      <PathwayGuidanceVerdict
        v-else-if="step.steppable.verdict"
        class="p-4 mr-8"
        :guidance="step.steppable"
        :verdict="step.steppable.verdict"
      />
      <div class="flex flex-col flex-1 w-full">
        <div class="flex flex-1 flex-row justify-between p-5">
          <markdown
            :content="description"
            class="text-left"
            inherit-styles
          />
        </div>
        <!-- No Mailiz webmail shortcut here: the prefilled MSSanté sending
             lives on the survey step, where the completed instance is known. -->
        <div class="flex flex-row items-center justify-between p-5">
          <DMPButton />
          <BaseButton
            :primary="true"
            class="text-sm font-semibold"
            @click="$emit('start', step)"
          >
            {{ action }}
          </BaseButton>
        </div>
      </div>
    </div>
    <PathwayStepInsert
      v-if="active"
      :step="step"
    />
  </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import Markdown from '@/core/components/markdown/Markdown.vue';
import BaseButton from '@/core/components/base/BaseButton.vue';
import PathwayGuidanceVerdict from '@/pathway/components/PathwayGuidanceVerdict.vue';
import PathwayStepInsert from '@/pathway/components/PathwayStepInsert.vue';
import DMPButton from "@/core/components/buttons/DMPButton.vue";
import {Pathway} from "@/program/interfaces/Program";

export default defineComponent({
    name: 'PathwayGuidanceStep',
    components: {DMPButton, PathwayStepInsert, PathwayGuidanceVerdict, BaseButton, Markdown},
    props: {
        pathway: {
            type: Object as PropType<Pathway>,
            required: true
        },
        step: {
            type: Object,
            required: true
        },
        consumerKey: {
            type: String,
            required: true
        },
        active: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: ['start'],
    computed: {
        description() {
            return this.step.resolved.description;
        },
        action() {
            return this.step.resolved.action;
        }
    }
});
</script>
